import Link from 'next/link';

import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { CanvasFooterReviews } from 'themes/canvas/components/FooterReviews/CanvasFooterReviews';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';
import { CanvasTeamSection } from 'themes/canvas/components/TeamSection/CanvasTeamSection';

import { Heading } from 'components/Heading';

import { useNavigation } from 'hooks/navigation/useNavigation';
import { useAboutPage } from 'hooks/page/about/useAboutPage';
import { useHomePage } from 'hooks/page/home/useHomePage';
import { usePortfolioImages } from 'hooks/portfolio/usePortfolioImages';

import { TService } from 'types/service';

import { CanvasAboutSection } from './components/CanvasAboutSection';
import { CanvasCancellationPolicy } from './components/CanvasCancellationPolicy/CanvasCancellationPolicy';

import s from './CanvasAbout.module.css';

const CanvasAbout = () => {
  const {
    aboutText,
    professionals,
    hasCancellationPolicy,
    cancellationPolicyText,
    showTeam,
    handleBook,
  } = useAboutPage();

  const { services } = useHomePage();
  const { showPortfolio } = useNavigation();

  const { images, isLoading } = usePortfolioImages();

  const items = services.map((service: TService) => service.name);

  return (
    <>
      <main className={s.aboutMain}>
        <section className={s.container}>
          <CanvasAnimatedTile
            threshold={aboutText && aboutText.length > 200 ? 0 : 0.3}
          >
            <CanvasAboutSection
              about={aboutText}
              image={images && images[0]}
              loading={isLoading}
              showPortfolio={showPortfolio}
            />
          </CanvasAnimatedTile>
          <CanvasAnimatedTile
            threshold={
              cancellationPolicyText && cancellationPolicyText.length > 200
                ? 0
                : 0.3
            }
          >
            {hasCancellationPolicy && (
              <CanvasCancellationPolicy
                cancellationPolicyText={cancellationPolicyText}
                image={images && images[1]}
                loading={isLoading}
                showPortfolio={showPortfolio}
              />
            )}
          </CanvasAnimatedTile>
          {/* Todo: for some reason showTeam is false when I have it set to true in app */}
          {/* eslint-disable-next-line sonarjs/no-redundant-boolean*/}
          {showTeam && (
            <div className={s.teamSection}>
              <Heading as="h1" variant="large" className={s.heading}>
                TEAM
              </Heading>
              <div className={s.teamSectionContainer}>
                <CanvasTeamSection
                  handleBook={handleBook}
                  professionals={professionals}
                />
              </div>
              <div className={s.viewMoreContainer}>
                <Link href="/team">View Full Team</Link>
              </div>
            </div>
          )}
        </section>
      </main>
      <section className={s.marquee}>
        <Marquee items={items} />
      </section>

      <CanvasFooterReviews />
    </>
  );
};

export { CanvasAbout };
